import React, { useState } from 'react';
import MegaMenu from './MegaMenu';
import { NavLink } from 'react-router-dom';

type DropdownItem = { name: string; pageId: string };

type DropdownProps = { name: string; pageId: string; items: DropdownItem[]; isMobile: boolean };

const Dropdown: React.FC<DropdownProps> = ({ name, pageId, items, isMobile }) => {
  const [isOpen, setIsOpen] = useState(false);
  const baseLinkClasses = "bg-transparent appearance-none outline-none px-2 py-1 transition-colors duration-200 text-sm font-medium";
  const desktopLinkClasses = `${baseLinkClasses} hover:text-gray-900`;
  const mobileLinkClasses = "block w-full text-left py-3 px-4 hover:bg-gray-50 transition-colors duration-200";

  if (isMobile) {
    return (
      <div className="w-full">
        <button type="button" onClick={() => setIsOpen(!isOpen)} className={`${mobileLinkClasses} flex justify-between items-center`}> 
          {name}
          <span className="text-gray-400">{isOpen ? '▲' : '▼'}</span>
        </button>

        {isOpen && (
          <ul className="bg-gray-50 border-l-4 border-gray-200 ml-4">
            {items.map((subItem) => (
              <li key={subItem.name}>
                <NavLink to={`/${subItem.pageId}`} onClick={() => { setIsOpen(false); }} className={({ isActive }) => `block w-full text-left pl-8 py-2 text-sm text-gray-600 hover:bg-gray-100 ${isActive ? 'font-bold text-gray-900 bg-gray-100' : ''}`}>
                  {subItem.name}
                </NavLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  return (
    <li className="relative group has-dropdown" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <NavLink to={`/${pageId}`} className={({ isActive }) => `${desktopLinkClasses} ${isActive ? 'text-gray-900' : 'text-gray-700'}`}>
        {name}
      </NavLink>

      {isOpen && (
        <MegaMenu columns={[items]} />
      )}
    </li>
  );
};

export default Dropdown;
